import { render, staticRenderFns } from "./sidebarPortfolio.vue?vue&type=template&id=529d74a8&"
import script from "./sidebarPortfolio.vue?vue&type=script&lang=js&"
export * from "./sidebarPortfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports